
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FolderItemProps } from ".";
import { loading, create } from "store/folder";

interface ApiFolderCreateInputProps extends Omit<FolderItemProps, "id"> {
    parentId?: number;
}

type ApiFolderCreateOutputProps = OutputBaseProps<{ item: FolderItemProps; }, ApiFolderCreateInputProps>;

export const apiFolderCreate = async (data: ApiFolderCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiFolderCreateOutputProps>("/api/folder/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};